<script setup lang="ts">
import Tooltip from '@/shared/ui/tooltip';

const msg = 'Ограничения обработки видео';
const tooltipMsg = 'По техническим причинам загрузка и обработка видео временно недоступна.';
</script>

<template>
  <tooltip
    class="tooltip"
    :content="tooltipMsg"
  >
    <div class="attention-chips">
      <img
        src="/icons/attention.svg"
        class="icon"
        alt="Attention Ships"
      />

      <span class="msg text-sm regular">{{ msg }}</span>
    </div>
  </tooltip>
</template>

<style scoped lang="postcss">
.tooltip {
  .attention-chips {
    --spacing: var(--space-s-var_01);
    --color-attention: 239 102 25;
    --duration: 300ms;
    --max-width: 42px;
    --msg-opacity: 0;

    display: flex;
    align-items: center;
    padding: var(--spacing);
    max-width: var(--max-width);
    overflow: hidden;

    border: 1px solid var(--color-white-12);

    border-radius: var(--border-radius-rounded);
    background:
      radial-gradient(
        50% 50% at 50% 50%,
        rgb(var(--color-attention) / 40%) 0,
        rgb(var(--color-attention) / 0%) 100%
      ),
      rgb(var(--color-attention) / 4%);
    font-size: 0;

    transition: max-width var(--duration) ease-in-out;
    cursor: pointer;

    .msg {
      padding-left: var(--spacing);
      white-space: nowrap;
      transition: opacity var(--duration) var(--timing-function);
      opacity: var(--msg-opacity);
    }
  }

  &:hover {
    .attention-chips {
      --max-width: 260px;
      --msg-opacity: 1;
    }
  }
}
</style>
